import { object, string, number, array, addMethod, mixed, boolean } from '@calendly/form/validation'

addMethod(object, 'uniqueProperty', function objectUnique(propertyName, message) {
  return this.test('unique', message, function uniqueValue(value) {
    if (!value || !value[propertyName]) return true

    const { path } = this
    const options = [...this.parent]
    const subOptions = options.slice(0, options.indexOf(value))

    if (subOptions.some((option) => option[propertyName] === value[propertyName])) {
      throw this.createError({
        path: `${path}.${propertyName}`,
        message,
      })
    }

    return true
  })
})

export const getValidationSchema = () => object({
  invitations: array().of(
    object({
      id: string(),
      role: string().oneOf(['admin', 'user']),
      userGroupRole: string().oneOf(['admin', 'user', null]).nullable(true),
      userGroupId: number().integer().nullable(true),
      email: string()
        .email((obj) => [[{ key: 'invalid', value: obj.value }]])
        .required((obj) => [[{ key: 'blank', value: obj.value }]])
    }).uniqueProperty('email', (obj) => [[{ key: 'duplicate_entry', value: obj.value.email }]])
  ),
  groupId: number().integer().nullable(true),
  eventTypeIds: mixed().when('groupId', {
    is: (groupId) => groupId,
    then: array().length(0),
    otherwise: array().of(string())
  }),
  modal: boolean().nullable(true)
})
